<ng-container *ngIf="state?.userProfile as profile">
  <!--   AUTHOR PHOTO OR INITIALS   -->
  <div class="author-photo" [style.width.px]="state?.avatarImgSize" [style.height.px]="state?.avatarImgSize">
    <img
      *ngIf="profile.avatarImageName; else initials"
      [width]="state?.avatarImgSize"
      height="auto"
      loading="eager"
      alt="author photo"
      [src]="env.clubsStaticAWS + '/profile/' + profile.avatarImageName | bypassSanitizer: 'url'"
    />
  </div>
  <ng-template #initials>
    {{ profile.fullName ?? 'John Doe' | initials }}
  </ng-template>

  <!--   AUTHOR FULL NAME   -->
  <div class="santa-flex santa-typo-secondary santa-flex-col" [style.marginLeft.px]="state?.spacingBetween">
    <!--  DIRECTION COL  -->
    <ng-container *ngIf="state?.direction === 'col'; else row">
      <span [class.santa-font-gbold]="state?.fullNameStyle === 'bold'">
        {{ profile.fullName }}
      </span>
      <span *ngIf="state?.separator">&nbsp;{{ state?.separator }}&nbsp;</span>
      <span *ngIf="profile.position">{{ profile.position }}</span>
    </ng-container>

    <!--  DIRECTION ROW  -->
    <ng-template #row>
      <span [class.santa-font-gbold]="state?.fullNameStyle === 'bold'"
        >{{ profile.fullName }}<ng-container *ngIf="state?.separator">&nbsp;{{ state?.separator }}&nbsp;</ng-container>
        <ng-container *ngIf="profile.position">{{ profile.position }}</ng-container>
      </span>
    </ng-template>
  </div>
</ng-container>
